import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';

import { VpStripePlanInfoAlert } from '../..';
import { VpStripeInputs } from './VpStripeInputs';

export const VpStripeForm = ({ plan, onApplyCode }) => {
  return (
    <Box>
      <VpStripePlanInfoAlert plan={plan} onApplyCode={onApplyCode} />
      <VpStripeInputs />
    </Box>
  );
};

VpStripeForm.propTypes = {
  plan: PropTypes.object,
  onApplyCode: PropTypes.func
};

export default VpStripeForm;



// WEBPACK FOOTER //
// ./src/vp-ui/widgets/Stripe/VpStripeForm.jsx